import { useState } from 'react'
import {
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  AppLayout,
  useGetOkProgramsQuery
} from 'prove-common'
import { OkProgramTable } from '../tables/ok-program-table/OkProgramTable'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { OkProgramForm } from '../components/reference-data/ReferenceEntityForms'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const OkProgramScreen = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const {
    data: okPrograms,
    isFetching,
    isError,
    refetch
  } = useGetOkProgramsQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='OK-program' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='OK-program'
            description='Overvåkings- og kontrollprogrammer med navn og unike OK-numre.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setModalOpen(true)}
              >
                <PlusIcon />
                Legg til OK-program
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={okPrograms != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {okPrograms ? <OkProgramTable okPrograms={okPrograms} /> : null}
      </ScreenLayout>
      {isModalOpen && <OkProgramForm onClose={() => setModalOpen(false)} />}
    </AppLayout>
  )
}
